import { useParams, useSearchParams } from "react-router-dom";
import TranslationWrapper from "./translationWrapper";
import { useQuery, gql } from "@apollo/client";
import { useEffect, useState } from "react";
import NameTableTranslatable from "./nameTableTranslateable";

import { GraphQLPagination } from "../common";
import { getQueryVariables } from "../../utils";
import CollectionTranslationForm from "./collectionTranslationForm";

const GET_COLLECTION = gql`
query MyQuery ($first: Int, $after: String, $last: Int, $before: String) {
    collections(first: $first, after: $after, last: $last, before: $before)
    {
    edges {
      node {
        dbId
        name
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}`
function CollectionTranslation() {
    const { languageCode } = useParams<{ languageCode: string }>();
    const [collectionId, setTranslationId] = useState<number | null>(null);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const { data, loading, error } = useQuery(GET_COLLECTION, {
        variables: getQueryVariables(searchParams),
        notifyOnNetworkStatusChange: true,
    })

    const handleOpenForm = (id: number) => {
        setIsFormOpen(true);
        setTranslationId(id);
    };

    const handleCloseForm = () => setIsFormOpen(false);

    useEffect(() => {
        if (!searchParams.get("first") && !searchParams.get("last")) {
            setSearchParams({ first: "20" });
        }
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    const collection = data?.collections?.edges || [];

    return (
        <TranslationWrapper>
            <>
                <NameTableTranslatable data={collection} onOpenForm={handleOpenForm} />

                <GraphQLPagination
                    edges={data?.collections?.edges || []}
                    pageInfo={data?.collections?.pageInfo || {}}
                />

                {isFormOpen && (
                    <CollectionTranslationForm
                        id={collectionId}
                        isOpen={isFormOpen}
                        onClose={handleCloseForm}
                    />
                )}

            </>
        </TranslationWrapper>
    );
}

export default CollectionTranslation;